import { IDocumentFilterNew, IDocumentSimple } from '@/interfaces/deltaGpt/IDocument.ts';
import { IIdNameBase } from '@/interfaces/general/IIdName.ts';

export function findNodePath<T> (
    nodes: Array<T>,
    targetKey: string,
    getKey: (node: T) => string,
    getChildren: (node: T) => Array<T> | undefined,
): Array<T> | null {
    let foundPath: Array<T> | null = null;

    nodes.forEach((node) => {
        if (foundPath) return;

        if (getKey(node) === targetKey) {
            foundPath = [node];
            return;
        }

        const childPath = findNodePath(getChildren(node) ?? [], targetKey, getKey, getChildren);
        if (childPath) foundPath = [node, ...childPath];
    });

    return foundPath;
}

function collectFilterIdNames (filters: Array<IDocumentFilterNew>, map: Map<string, string>): Map<string, string> {
    filters.forEach((f: IDocumentFilterNew): void => {
        map.set(f.filterCategory.id, f.filterCategory.name);
        collectFilterIdNames(f.filters, map);
    });

    return map;
}

export function getFiltersForDocuments (docs: Array<IDocumentSimple>): Array<IIdNameBase> {
    const map = new Map<string, string>();

    docs.forEach((doc): void => {
        collectFilterIdNames(doc.filters, map);
    });

    return Array.from(map, ([id, name]) => ({ id, name }));
}

export function getFiltersForDocument (doc: IDocumentSimple): Array<IIdNameBase> {
    return getIdNames(doc.filters);
}

export function getIdNames (filters: Array<IDocumentFilterNew>) : Array<IIdNameBase> {
    const map = new Map<string, string>();

    collectFilterIdNames(filters, map);

    return Array.from(map, ([id, name]) => ({ id, name }));
}

export function getNames (filters: Array<IDocumentFilterNew>) : Array<string> {
    const map = new Map<string, string>();

    collectFilterIdNames(filters, map);

    return Array.from(map, ([, name]) => name);
}

export function getIds (filters: Array<IDocumentFilterNew>) : Array<string> {
    const map = new Map<string, string>();

    collectFilterIdNames(filters, map);

    return Array.from(map, ([id]) => id);
}
